var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.71 58.707C500.023 42.232 483.786 32 465.337 32H46.654C28.204 32 11.968 42.232 4.283 58.707C-3.196 74.734 -0.758 93.158 10.644 106.787L175.995 309.912V377.619C175.995 390.166 182.173 401.922 192.519 409.066L274.835 472.617C281.997 477.613 289.578 480 297.408 480C318.685 480 335.995 462.807 335.995 441.67V309.912L501.486 106.623C512.749 93.158 515.187 74.734 507.71 58.707ZM295.187 283.986C290.535 289.699 287.995 296.844 287.995 304.215V422.113L223.995 372.725V304.215C223.995 296.844 221.456 289.699 216.804 283.986L50.773 80.037H461.214L295.187 283.986Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.13285e815066c6fc293ac73a85b436d9.svg";
export { ForwardRef as ReactComponent };